import { tv } from '~/utils/tv'

export const CardInformativeIconVariants = tv({
  base: `
  flex items-center
  `,
  variants: {
    type: {
      text: '',
      icon: '',
      highlight:
        'max-h-large min-h-large min-w-large max-w-large items-center justify-center rounded-pill bg-fill-neutral',
    },
  },
})
